import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Tentacle extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.cont = null;
    this.signCont = null;

    this.tentacle = null;
    this.signF = null;
    this.signB = null;

    this.tentacleTween = null;
    this.signTween = null;
    this.waveTween = null;

    this.setup();
  }

  setup () {
    this.signDel = 4000;

    this.createTentacle();
  }

  createTentacle () {
    this.cont = this.scene.add.container();
    this.add(this.cont);

    this.tentacle = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._1_Welcome_and_Level_Screen_SoundSign_Tentacle, this.cont).setOrigin(0.5, 1);

    this.createSign();

    this.octoWave = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._1_Welcome_and_Level_Screen_OctoWave, this).setOrigin(0.5);

    this.setPosition(375, 729);
    this.cont.setPosition(0, 275);

    this.cont.angle = -5;

    ABCyaPhaser.Tweens.addTween(this.cont, 1000, { y: 5, delay: 3000 },Phaser.Math.Easing.Quadratic.Out, () => this.waveTentacle());

    this.waveTween = ABCyaPhaser.Tweens.addTween(this.octoWave, 3000, { x: -30, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  createSign () {
    this.signCont = this.scene.add.container(-15, -230).setAngle(-5);
    this.cont.add(this.signCont);

    this.signB = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._1_Welcome_and_Level_Screen_SoundSign1, this.signCont).setOrigin(0.5);

    this.signF = ABCyaPhaser.Images.addImage(0, 0,UIAssetKeys._1_Welcome_and_Level_Screen_SoundSign2, this.signCont).setOrigin(0.5);
  }

  waveTentacle () {
    this.tentacle.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleClick, this);
    this.signB.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleClick, this);
    this.signF.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleClick, this);

    this.signBack();

    this.tentacleTween = ABCyaPhaser.Tweens.addTween(this.cont, 5000, { angle: 10, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  handleClick () {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._turn_sound_on, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.tentacle.disableInteractive();
    this.signB.disableInteractive();
    this.signF.disableInteractive();

    this.scene.time.delayedCall(2500, () => {
      this.tentacle.setInteractive();
      this.signB.setInteractive();
      this.signF.setInteractive();
    });
  }

  signBack () {
    this.signTween = ABCyaPhaser.Tweens.addTween(this.signCont, 300, { scaleX: 0.05, scaleY: 1.3, delay: this.signDel }, Phaser.Math.Easing.Quadratic.InOut, () => this.showBack());

    this.tentacleTween = ABCyaPhaser.Tweens.addTween(this.cont, 300, { scaleY: 0.9, delay: this.signDel }, Phaser.Math.Easing.Back.Out);
  }

  showBack () {
    this.signF.alpha = 0;

    this.signTween = ABCyaPhaser.Tweens.addTween(this.signCont, 300, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.InOut, () => {
      this.signFront();
    });

    this.tentacleTween = ABCyaPhaser.Tweens.addTween(this.cont, 300, { scaleY: 1 }, Phaser.Math.Easing.Back.In);
  }

  signFront () {
    this.signTween = ABCyaPhaser.Tweens.addTween(this.signCont, 300, { scaleX: 0.05, scaleY: 1.3, delay: this.signDel }, Phaser.Math.Easing.Quadratic.InOut, () => {
      this.showFront();
    });

    this.tentacleTween = ABCyaPhaser.Tweens.addTween(this.cont, 300, { scaleY: 0.9, delay: this.signDel }, Phaser.Math.Easing.Back.Out);
  }

  showFront () {
    this.signF.alpha = 1;

    this.signTween = ABCyaPhaser.Tweens.addTween(this.signCont, 300, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.InOut, () => {
      this.signBack();
    });

    this.tentacleTween = ABCyaPhaser.Tweens.addTween(this.cont, 300, { scaleY: 1 }, Phaser.Math.Easing.Back.In);
  }

  stopAnims () {
    this.scene.tweens.killTweensOf(this.signCont);
    this.scene.tweens.killTweensOf(this.cont);
    this.scene.tweens.killTweensOf(this.octoWave);

    this.signTween.stop();
    this.waveTween.stop();
    this.tentacleTween.stop();
  }

  tweenOut () {
    this.stopAnims();

    this.tentacleTween = ABCyaPhaser.Tweens.addTween(this.cont, 1000, { angle: -5, y: 275 }, Phaser.Math.Easing.Quadratic.In);
  }

  cleanUp () {
    this.tentacle.disableInteractive();
    this.signB.disableInteractive();
    this.signF.disableInteractive();

    this.stopAnims();

    this.signCont.destroy();
    this.cont.destroy();
    this.octoWave.destroy();
  }
}